import styles from "@src/Pages/SettingsPage/settingsPage.module.less";
import {Stack} from "@src/CommonComponents/Stack/Stack.tsx";

import remarkParse from 'remark-parse';
import remarkGfm from 'remark-gfm';
import remarkRehype from 'remark-rehype';
import rehypeSanitize from 'rehype-sanitize';
import rehypeStringify from 'rehype-stringify';
import {unified} from 'unified';
import {useEffect, useState} from "react";
import cn from "classnames";


export const mdToHtml = async (md: string) => {
    const file = await unified()
        .use(remarkParse)
        .use(remarkGfm)
        .use(remarkRehype)
        .use(rehypeSanitize) // важный шаг
        .use(rehypeStringify)
        .process(md);
    return String(file);
}


export const MDDispatcher = ({file}: {file: any}) => {
    const [html, setHtml] = useState<string>('');
    useEffect(() => {
        let cancel = false;
        mdToHtml(file).then(res => !cancel && setHtml(res));
        return () => {
            cancel = true;
        };
    }, [file]);
    return (
        <Stack direction={"column"} gap={8} className={styles.subPage} alignItems={"center"}>
            <Stack className={cn(styles.whiteBoard, styles.text)} gap={16} justifyContent={"flex-start"}
                   direction={"column"}>
                {html && <div dangerouslySetInnerHTML={{__html: html}}/>}
            </Stack>
        </Stack>
    )
}